import React from "react";

// Latvian folk pattern divider — Auseklis (morning star) repeated subtly.
// Use sparingly per design guidelines (max twice on whole site).
export default function FolkDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-3 py-12 ${className}`} aria-hidden="true">
      <span className="h-px w-16 sm:w-24 bg-walnut/30" />
      <svg width="28" height="28" viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1" className="text-walnut">
        <path d="M20 2 L24 16 L38 20 L24 24 L20 38 L16 24 L2 20 L16 16 Z" />
        <path d="M20 12 L22 18 L28 20 L22 22 L20 28 L18 22 L12 20 L18 18 Z" />
      </svg>
      <span className="h-px w-16 sm:w-24 bg-walnut/30" />
    </div>
  );
}
